import { Component, inject } from '@angular/core';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { stages } from '../../general-letter.routes';
import { GeneralLetterInformationForm } from './forms/general-letter-information.form';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';
import { ApplicationCommonComponent } from '../../../common/application.common.component';

@Component({
  selector: 'app-general-letter-information-section',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SpinnerComponent,
    StagesComponent,
    ValidationErrorsComponent
  ],
  providers: [GeneralLetterInformationForm],
  templateUrl: './general-letter-information-section.component.html'
})
export class GeneralLetterInformationSectionComponent extends ApplicationCommonComponent {

  public successUrl: string = this.route.snapshot.data['successUrl'];

  public stages: string[] = stages;

  public form: GeneralLetterInformationForm = inject(GeneralLetterInformationForm);

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication('dane-identyfikacyjne', this.form.value);
      } else {
        this.createApplication('dane-identyfikacyjne', this.form.value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };
}
